import axios from 'axios';

export const getStockages = async (params = "") => {
    const ApiUrl = `${process.env.REACT_APP_PUBLIC_API}/stockages${params}`;
    // L'intercepteur global ajoutera automatiquement le token
    return axios.get(ApiUrl).then((response) => response.data);
}

export const getStockagesById = async (id) => {
    const ApiUrl = `${process.env.REACT_APP_PUBLIC_API}/stockages/${id}`;
    // L'intercepteur global ajoutera automatiquement le token
    return axios.get(ApiUrl).then((response) => response.data);
}

export const createStockage = async (stockage) => {
    const ApiUrl = `${process.env.REACT_APP_PUBLIC_API}/stockages`;
    return axios.post(ApiUrl, JSON.stringify(stockage), {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((response) => response.data);
}

export const updateStockage = async (id, stockage) => {
    const ApiUrl = `${process.env.REACT_APP_PUBLIC_API}/stockages/${id}`;
    return axios.put(ApiUrl, stockage).then((response) => response.data);
}

export const deleteStockage = async (id) => {
    const ApiUrl = `${process.env.REACT_APP_PUBLIC_API}/stockages/${id}`;
    return axios.delete(ApiUrl).then((response) => response.data);
}